// Internal dependencies
import { isUrlAbsolute } from '../parse-query-string';

export const getVisitorUrl = (redirectToParam: string) => {
  const redirectTo = decodeURIComponent(redirectToParam);
  return !isUrlAbsolute(redirectToParam) ? `${window.location.origin}${redirectTo}` : redirectTo;
};
